import React, { useState, useEffect } from 'react';
import EventsDisplayArea from './EventsDisplayArea';
import  SharedSpace  from './SharedSpace';
import { FileText, Users } from 'lucide-react';
import { useSharedEvents } from '../TIMEBAR/SharedEventsContext';
import './RightPanel.css';

const RightPanel = () => {
  const [activeTab, setActiveTab] = useState('workspace');
  const [pendingNotifications, setPendingNotifications] = useState({
    workspace: 0,
    shared: 0
  });
  
  const { sharedEvents } = useSharedEvents();
  
  // Update notifications when shared events change
  useEffect(() => {
    // Count new items saved to workspace (for notification badges)
    const workspaceEvents = sharedEvents.filter(event => {
      const savedTo = Array.isArray(event.savedTo) ? event.savedTo : [event.savedTo || 'workspace'];
      return savedTo.includes('workspace') && !event.viewed;
    });
    
    // Count new items shared with team
    const sharedWithTeamEvents = sharedEvents.filter(event => {
      const savedTo = Array.isArray(event.savedTo) ? event.savedTo : [event.savedTo || 'workspace'];
      return savedTo.includes('shared') && !event.viewed;
    });
    
    setPendingNotifications({
      workspace: workspaceEvents.length,
      shared: sharedWithTeamEvents.length
    });
  }, [sharedEvents]);
  
  // Clear notifications when tab is selected
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    
    // Reset notification count for the selected tab
    if (tab === 'workspace' || tab === 'shared') {
      setPendingNotifications(prev => ({
        ...prev,
        [tab]: 0
      }));
    }
  };

  return (
    <div className="right-panel-container">
      <div className="right-panel">
        <div className="right-panel-tabs">
          <button
            className={`tab-button ${activeTab === 'workspace' ? 'active' : ''}`}
            onClick={() => handleTabChange('workspace')}
          >
            <FileText size={16} />
            Saved
            {pendingNotifications.workspace > 0 && (
              <span className="notification-badge">{pendingNotifications.workspace}</span>
            )}
          </button>
          
          <button
            className={`tab-button ${activeTab === 'shared' ? 'active' : ''}`}
            onClick={() => handleTabChange('shared')}
          >
            <Users size={16} />
            Shared
            {pendingNotifications.shared > 0 && (
              <span className="notification-badge">{pendingNotifications.shared}</span>
            )}
          </button>
        </div>
        
        <div className="right-panel-content">
          {activeTab === 'workspace' && (
            <EventsDisplayArea source="workspace" />
          )}
          
          {activeTab === 'shared' && (
            <SharedSpace />
          )}
        </div>
      </div>
    </div>
  );
};

export default RightPanel;